interface User {
    uuid: string
    name: string
    status: string
    department: string
    role: string
    roleName: string
    email: string
    level: string
    departmentUuid: string
}

interface UsersResponse {
    results: User[]
}

interface UserDataResponse {
    data: {
        department: string
        departmentUuid: string
        status: string
    }
}

// format User list
export function formatUserList(response: UsersResponse): User[] {
    return response.results
}

// format user data response 讓用戶資訊符合 routerProtect 需要的格式。
export function formatUserDataToRouterProtectStyle(userDataResponse: UserDataResponse) {
    const result = {
        data: {
            creator: {
                department: {
                    name: userDataResponse.data.department,
                    uuid: userDataResponse.data.departmentUuid,
                },
                name: "",
                role: {
                    name: "",
                    slug: "",
                    level: "",
                },
                uuid: "",
            },
            status: userDataResponse.data.status,
        },
    }
    return result
}
